import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
import { painPoints } from '../data/offer';
export function PainPoints() {
  return <section className="bg-brand-ink px-4 py-16 sm:py-24" data-id="element-84" data-mp="26yfs1jcmjdn6">
      <div className="mx-auto max-w-4xl" data-id="element-85" data-mp="26xwk8vgou5mv">
        <header className="text-center" data-id="element-86" data-mp="2bxiwp2oozhum">
          <h2 className="font-display text-3xl font-bold sm:text-5xl" data-id="element-87" data-mp="2bw7uh7awai5m">
            ¿Cuánto tiempo más vas a quedarte sin saber qué hacer después de una
            discusión?
          </h2>
          <p className="mx-auto mt-6 max-w-3xl text-slate-300" style={{
          fontSize: '15px'
        }} data-id="element-88" data-mp="220e8kxbadcb6">
            Sos una cuidadora que se entrega al 100%. Pero cuando discutís con tu
            familiar durante el cuidado, quedás paralizada sin saber cómo volver a
            acercarte.
          </p>
          <p className="mt-4 font-semibold text-brand-light" data-id="element-89" data-mp="3idbgty4zivhg">
            El problema no es tu esfuerzo. Es que te faltaba una hoja de ruta para
            volver a acercarte.
          </p>
        </header>
        <div className="mt-10 space-y-3" data-id="element-90" data-mp="1yzn53nbw7eho">
          {painPoints.map((point, index) => <motion.div key={point} initial={{
          opacity: 0,
          x: -14
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="flex gap-3 rounded-xl border border-red-900/70 bg-[#250c0c] p-4 sm:p-5" data-id="element-91" data-mp="1u2dh8c45javy" data-mpi={index}>
              <XCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-red-500" aria-hidden="true" data-id="element-92" data-mp="1g3x2bxw4ye2q" />
              <p className="text-sm leading-relaxed text-slate-200 sm:text-base" data-id="element-93" data-mp="1b4subaky6mdz">{point}</p>
            </motion.div>)}
        </div>
        <p className="mt-12 text-center font-display text-2xl font-bold italic text-brand-gold sm:text-3xl" data-id="element-94" data-mp="1k2wdw1cdh935">
          ¿Y si tuvieras una hoja de ruta clara para saber qué hacer después de una
          discusión?
        </p>
      </div>
    </section>;
}